// src/admin/pages/Users/components/CreateUserForm.js
import React, { useState } from "react";

const palette = {
  primary: "#FF8C00",
  secondary: "#FF6600",
  background: "#FAFAFA",
  card: "#FFFFFF",
  overlay: "rgba(0,0,0,0.4)",
  textDark: "#333333",
  textLight: "#FFFFFF"
};

const styles = {
  formCard: {
    backgroundColor: palette.card,
    border: "1px solid #ddd",
    borderRadius: "4px",
    padding: "20px",
    marginBottom: "20px",
    boxShadow: "0px 2px 5px rgba(0,0,0,0.1)"
  },
  formTitle: {
    color: palette.textDark,
    marginBottom: "15px"
  },
  form: {
    display: "flex",
    flexDirection: "column"
  },
  label: {
    color: palette.textDark,
    marginBottom: "5px"
  },
  input: {
    marginBottom: "15px",
    padding: "8px",
    border: "1px solid #ccc",
    borderRadius: "3px"
  },
  select: {
    marginBottom: "15px",
    padding: "8px",
    border: "1px solid #ccc",
    borderRadius: "3px"
  },
  formButtons: {
    display: "flex",
    gap: "10px"
  },
  saveButton: {
    backgroundColor: palette.primary,
    color: palette.textLight,
    border: "none",
    padding: "8px 16px",
    cursor: "pointer"
  },
  cancelButton: {
    backgroundColor: "#999",
    color: "#fff",
    border: "none",
    padding: "8px 16px",
    cursor: "pointer"
  }
};

export default function CreateUserForm({ onCancel, onSubmit, restaurants }) {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("waiter");
  const [restaurantId, setRestaurantId] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      username,
      email,
      password,
      role,
      restaurant_id: role === "admin" ? null : Number(restaurantId) || null
    });
  };

  return (
    <div style={styles.formCard}>
      <h2 style={styles.formTitle}>Crea Utente</h2>
      <form onSubmit={handleSubmit} style={styles.form}>
        <label style={styles.label}>Username</label>
        <input
          style={styles.input}
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />

        <label style={styles.label}>Email</label>
        <input
          style={styles.input}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <label style={styles.label}>Password</label>
        <input
          style={styles.input}
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <label style={styles.label}>Ruolo</label>
        <select style={styles.select} value={role} onChange={(e) => setRole(e.target.value)}>
          <option value="admin">admin</option>
          <option value="chef">chef</option>
          <option value="waiter">waiter</option>
        </select>

        {role !== "admin" && (
          <>
            <label style={styles.label}>Ristorante</label>
            <select
              style={styles.select}
              value={restaurantId}
              onChange={(e) => setRestaurantId(e.target.value)}
            >
              <option value="">Seleziona</option>
              {restaurants.map((r) => (
                <option key={r.id} value={r.id}>
                  {r.name}
                </option>
              ))}
            </select>
          </>
        )}

        <div style={styles.formButtons}>
          <button style={styles.saveButton} type="submit">
            Salva
          </button>
          <button style={styles.cancelButton} onClick={onCancel}>
            Annulla
          </button>
        </div>
      </form>
    </div>
  );
}
